import { clsx } from 'clsx';

interface SystemHealthBarProps {
  label: string;
  value: number; // 0-100 percentage
  usedText?: string; // e.g. "4.2 / 8 GB"
  className?: string;
}

function getFillColor(value: number): string {
  if (value <= 60) return 'bg-green-500';
  if (value <= 80) return 'bg-yellow-500';
  if (value <= 90) return 'bg-orange-500';
  return 'bg-red-500';
}

function SystemHealthBar({ label, value, usedText, className }: SystemHealthBarProps) {
  const clamped = Math.max(0, Math.min(100, value));

  return (
    <div className={clsx('space-y-1', className)}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-300">{label}</span>
        <span className="text-slate-100 font-medium">{Math.round(clamped)}%</span>
      </div>
      <div className="h-2 rounded-full bg-slate-700 overflow-hidden">
        <div
          className={clsx('h-full rounded-full transition-all duration-300', getFillColor(clamped))}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {usedText && <p className="text-sm text-slate-400">{usedText}</p>}
    </div>
  );
}

export default SystemHealthBar;
